import { render, staticRenderFns } from "./LocalesDropdown.vue?vue&type=template&id=4d4e4038&scoped=true"
import script from "./LocalesDropdown.vue?vue&type=script&lang=js"
export * from "./LocalesDropdown.vue?vue&type=script&lang=js"
import style0 from "./LocalesDropdown.vue?vue&type=style&index=0&id=4d4e4038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4e4038",
  null
  
)

export default component.exports